import React, { useState } from 'react';
import { VStack, Text, HStack, Icon, Box } from '@chakra-ui/react';
import { FiChevronDown, FiChevronUp, FiCalendar } from 'react-icons/fi';
import Button from '../base/Button';
import { useBookings } from '../../hooks/useRooms';
import { useTranslation } from '../../hooks/useTranslation';
import BookingCard from './BookingCard';
import Loader from '../base/Loader';

const BookingsList: React.FC = () => {
    const { t } = useTranslation();
    const { bookings, isLoading } = useBookings();
    const [isExpanded, setIsExpanded] = useState(false);

    if (isLoading) {
        return (
            <VStack gap={2} align="stretch" bg="white" p={4}>
                <Box minH="50px">
                    <Loader text={t.pages.support.loading} size="lg" />
                </Box>
            </VStack>
        );
    }

    if (!bookings || bookings.length === 0) {
        return (
            <VStack gap={2} align="center" bg="white" p={4}>
                <Icon as={FiCalendar} boxSize={8} alignSelf="center" color="gray.400" />
                <Text fontSize="md" color="black" textAlign="center">
                    {t.pages.office.noBookings}
                </Text>
            </VStack>
        );
    }

    const shouldShowMoreButton = bookings.length > 1;
    const displayedBookings = isExpanded ? bookings : bookings.slice(0, 1);

    return (
        <VStack gap={2} align="stretch" bg="white" p={4}>
            <Text fontSize="lg" fontWeight="bold" color="black">
                {t.pages.office.myBookings}
            </Text>
            {displayedBookings.map((booking, index) => (
                <>
                    <BookingCard key={booking.id} booking={booking} />
                    {index < displayedBookings.length - 1 && <Box h="1px" bg="gray.200" />}
                </>
            ))}
            {shouldShowMoreButton && (
                <Button buttonType="secondary" onClick={() => setIsExpanded(!isExpanded)} w="full">
                    <HStack gap={2} justify="center">
                        <Text>{isExpanded ? t.pages.office.hide : t.pages.office.showMore}</Text>
                        <Icon as={isExpanded ? FiChevronUp : FiChevronDown} boxSize={5} />
                    </HStack>
                </Button>
            )}
        </VStack>
    );
};

export default BookingsList;
